import React from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Settings } from "@piiqtechnologies/svg-icons";
import { useOrgPath } from "@stores/ActiveOrganizationContext";
import { reportSettingsTopicsPath } from "@utils/reportSettingsPath";
import messages from "../messages.i18n";
import { HeaderIconButton } from "./HeaderIconButton";
export const HeaderSettingsButton = ({ communityId, communityName, settingsId }) => {
    const intl = useIntl();
    const navigate = useNavigate();
    const orgPath = useOrgPath();
    const label = intl.formatMessage(messages.reportSettings);
    return (React.createElement(HeaderIconButton, { label: label, tooltip: label, disabled: !settingsId, icon: React.createElement(Settings, { width: 18, height: 18 }), onClick: () => {
            if (!settingsId)
                return;
            navigate(orgPath(reportSettingsTopicsPath(settingsId)), {
                state: { subjectId: communityId, communityName },
            });
        } }));
};
export default HeaderSettingsButton;
